import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  SwipeableDrawer,
  ThemeProvider,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import * as PropTypes from "prop-types";
import { sidebar, styles } from "./component.styles";
import { AccountBalance, Home, Logout, People, Smartphone } from "@mui/icons-material";
import Logo from "../assets/logo/rocketfuel-fulllogo.svg";
import { useDispatch, useSelector } from "react-redux";
import { signout } from "../store/actions";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation, useNavigate } from "react-router-dom";
import config from "../utils/config";
import About from '../assets/logo/about.svg';
import Statements from '../assets/logo/income-statement.svg';
import AppConfirmModal from '../components/AppConfirmModal';
import { useTranslation } from "react-i18next";
import { logEvent } from "../store/api";
import { EVENTS } from "../utils/events";
import { getReferalSelector } from "../utils/selectorHelpers";
export default function AppSideBar({ open = false, setOpen }) {
  const media = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const refer = useSelector(getReferalSelector);
  const fiatService = useSelector(({ dashboard }) => dashboard?.fiatService);
  const { t } = useTranslation();
  const [logout] = useState(false);
  const dispatch = useDispatch();
  const iOS =
    typeof navigator !== "undefined" &&
    /iPad|iPhone|iPod/.test(navigator.userAgent);
  const location = useLocation();
  const navigate = useNavigate();
  const toggleDrawer = (value) => {
    setOpen(value);
  };

  const handleLogout = (value, todo) => {
    // setLogout(value)
    // if (todo) {
    dispatch(signout());
    // }
  };
  const navigation = (path) => {
    if (`/bank`) {
      logEvent({
        current: EVENTS.BANK_TRANSFER.BANK_ACCOUNT_MENU_SELECTED,
        activity: EVENTS.BANK_TRANSFER.BANK_ACCOUNT_MENU_SELECTED,
        meta: {
          fiatService
        }
      })
    }
    navigate(path);
    setOpen(false);
  };
  return (
    <React.Fragment>
      <AppConfirmModal buttonTitle={t("Logout")} description={t("LogoutText")} open={logout} title={"Logout"} setOpen={handleLogout} />
      <SwipeableDrawer
        anchor={"left"}
        open={open}
        onClose={() => toggleDrawer(false)}
        onOpen={() => { }}
        disableBackdropTransition={!iOS}
        disableDiscovery={iOS}
      >
        <ThemeProvider theme={sidebar}>
          <Paper sx={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <Box
              padding={3}
              display="flex"
              alignItems="center"
              flexDirection={"row"}
              justifyContent="space-between"
            >
              <Logo style={styles.logo} />
              <IconButton onClick={() => setOpen(false)} aria-label="tracker"
                aria-describedby="close">
                <CloseIcon style={{ color: "#F8FAFF" }} aria-label="tracker"
                  aria-describedby="close" />
              </IconButton>
            </Box>
            <Box sx={{ flexGrow: 1 }}>

              <Box sx={{ width: media ? "100vw" : "25vw" }}>

                <List sx={{ width: media ? "100vw" : "25vw" }}>
                  <ListItem disablePadding selected={location.pathname === "/home"}>
                    <ListItemButton onClick={() => navigation("/home")}>
                      <ListItemIcon>
                        <Home htmlColor="#F8FAFF" />
                      </ListItemIcon>
                      <ListItemText primary={t('go.dashboard')} />
                    </ListItemButton>
                  </ListItem>
                  {!!(fiatService?.showSidebar) && <ListItem disablePadding selected={location.pathname === "/bank"}>
                    <ListItemButton onClick={() => navigation("/bank")}>
                      <ListItemIcon>
                        <AccountBalance htmlColor="#F8FAFF" />
                      </ListItemIcon>
                      <ListItemText primary={t('go.bank')} />
                    </ListItemButton>
                  </ListItem>}
                  <ListItem disablePadding selected={location.pathname === "/statements"}>
                    <ListItemButton onClick={() => navigation("/statements")}>
                      <ListItemIcon>
                        <Statements />
                      </ListItemIcon>
                      <ListItemText primary={t('statements')} />
                    </ListItemButton>
                  </ListItem>
                  <ListItem disablePadding selected={location.pathname === "/mfa"}>
                    <ListItemButton onClick={() => navigation("/mfa")}>
                      <ListItemIcon>
                        <Smartphone htmlColor="#F8FAFF" />
                      </ListItemIcon>
                      <ListItemText primary={"2FA"} />
                    </ListItemButton>
                  </ListItem>
                  <ListItem disablePadding >
                    <ListItemButton href={config.ABOUT_LINK} target="_blank">
                      <ListItemIcon>
                        <About />
                      </ListItemIcon>
                      <ListItemText primary={t('aboutUs')} />
                    </ListItemButton>
                  </ListItem>
                  {refer?.isEnabled && <ListItem disablePadding >
                    <ListItemButton onClick={() => navigation("/refer")}>
                      <ListItemIcon>
                        <People htmlColor="#F8FAFF" />
                      </ListItemIcon>
                      <ListItemText primary={t('invite.sidebar')} />
                    </ListItemButton>
                  </ListItem>}
                  <ListItem disablePadding onClick={handleLogout}>
                    <ListItemButton>
                      <ListItemIcon>
                        <Logout htmlColor="#F8FAFF" />
                      </ListItemIcon>
                      <ListItemText primary={t("Logout")} />
                    </ListItemButton>
                  </ListItem>
                </List>
              </Box>
            </Box>
          </Paper>
        </ThemeProvider>
      </SwipeableDrawer>
    </React.Fragment >
  );
}


AppSideBar.propTypes = {
  open: PropTypes.bool,
};
